export interface DiscordImportUser {
  id: string;
  username: string;
  globalName: string | null;
  avatar: string | null;
}

export interface CloudSession {
  authenticated: boolean;
  user?: DiscordImportUser;
}

export interface MortalImportPayload {
  preferences: unknown | null;
  apiRoutes: unknown | null;
}

async function json<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, { credentials: "same-origin", ...init });
  if (!response.ok) {
    const body = await response.json().catch(() => ({})) as { error?: string };
    throw new Error(body.error ?? `${response.status} ${response.statusText}`);
  }
  return response.json() as Promise<T>;
}

export const getCloudSession = () => json<CloudSession>("/api/auth/me");
export const fetchMortalImport = () => json<MortalImportPayload>("/api/cloud/mortal-import");
export const logoutCloudSession = () => json<{ ok: boolean }>("/api/auth/logout", { method: "POST" });
